import React, { useEffect, useState } from "react";
import { SlArrowRight } from "react-icons/sl";
import LogingDropList from "./LogingDropList";

const LoggingItem = ({ item }) => {
  const [styleLable, setStyleLable] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [openList, setOpenList] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        setOpenList(true);
      }, 100);
    } else setOpenList(false);
  }, [isOpen]);
  return (
    <div
      className={`notification_item_wrap ${
        openList ? "open_drop_menu" : "close_drop_menu"
      }`}
      onClick={() => setIsOpen((state) => !state)}
    >
      <div className={`notification_item_wrap_dropdown `}>
        <div className="img_notification">
          <img src={"/img/notif_img/Shield.svg"} alt="" />
          <div className={`notification_triger ${item.colorNotif} `}></div>
        </div>
        <div className="img_user">
          <img src={item.img} alt="" />
        </div>
        <div className="notification_info notification_info_logging">
          <h3>
            {" "}
            <p className="notification_info_name">{item.name}</p>{" "}
            <p className="notification_info_id_event">
              {" "}
              <span className="notification_info_id">{item.id} </span>{" "}
              {item.event}{" "}
            </p>
          </h3>
          <p>{item.date}</p>
        </div>
        <div className="notification_label">
          {/* {item?.lable.map((lable, idx) => (

                <p 
                className={lable}
                key={idx}>{lable}</p>
                ))} */}
        </div>
        <div className="notification_open-drop">
          <SlArrowRight className={`close_svg ${isOpen ? "open_svg" : ""}`} />
        </div>
      </div>
      <LogingDropList
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        lorem={"Detected an external link from FreeMoney#1248"}
      />
    </div>
  );
};

export default LoggingItem;
